import { TableViewComponent } from "../../component/table_view_component";
import { TableHelp } from "../../help/table_help";
import { SeatState } from "../../component/seat_state_component";
import { PokerComponent } from "../../component/poker_component";
import { Texas } from "../../../../net/proto/proto_texasholdem_game";
import SidePotEffect from "../../component/sidePot_effect";
import AtlasHandleComp from "../../component/atlas_component";
import { Define } from "../../data/const_define";
import CommonPokerComp from "../../component/common_poker_component";
import TexasSound from "../../../texas_sound";
import LanguageManager from "../../../../../../manager/language_manager";
import { Card } from "../../../../../table/module/poker_table/poker_table_common";
import TexasAnimEffect from "../../component/texas_animation_effect";

//牌桌UI
export class TableView{

    tabViewComp:TableViewComponent;

    //座椅
    seatPrefab:cc.Node;

    //任务信息预设
    seatPlayerPrefab:cc.Node;

    //座位根节点
    seatRoot:cc.Node;

    //当前牌桌节点
    tableRoot:cc.Node;

    Init(root:cc.Node){
        this.tableRoot = root;
        this.seatRoot = cc.find('seatRoot',this.tableRoot);
        this.tabViewComp = this.tableRoot.getComponent(TableViewComponent);
        this.seatPrefab = this.tabViewComp.seatPrefab;
        this.seatPlayerPrefab = this.tabViewComp.seatPlayerPrefab;
        for (let cf of this.twoCardsEffect) {
            cf.init();
        }
        this.onInit();
    }


    get seatInfo():SeatState[]{
        return this.tabViewComp.seatState;
    }

    get commonPokers():CommonPokerComp{
        return this.tabViewComp.commonPokers;
    }

    get pokerPrefab():cc.Node{
        return this.tabViewComp.pokerPrefab;
    }

    get sidePool():SidePotEffect{
        return this.tabViewComp.sidePool;
    }

    get dealerNode():cc.Node{
        return this.tabViewComp.dealerNode;
    }

    get checkBetNode():cc.Node{
        return this.tabViewComp.checkBetNode;
    }

    get dealer():cc.Node{
        return this.tabViewComp.dealer;
    }

    //设置盲注
    set blinds(str:string){
        this.tabViewComp.blindsLab.string = str;
    }

    get chatNode():cc.Node{
        return this.tabViewComp.chatNode;
    }

    get twoHands(){
        return this.tabViewComp.meHands;
    }

    get patternMask(){
        return this.tabViewComp.patternMask;
    }

    get twoCardsEffect(){
        return this.tabViewComp.twoCardsEffect;
    }

    get mainNode():cc.Node{
        return this.tabViewComp.mainNode;
    }

    get addBet():cc.Node{
        return this.tabViewComp.addBet;
    }

    get heguan():cc.Node{
        return this.tabViewComp.heguan;
    }

    get myTypeNode():cc.Node{
        return this.tabViewComp.myTypeNode;
    }

    get addAnim():TexasAnimEffect{
        return this.tabViewComp.addAnim
    }

    playAddBetAnim(start:boolean){

    }

    setSeatNumb(numb:number){
        this.tabViewComp.setSeatNumb(numb);
    }

    setPatternMask(isShow:boolean){
        this.patternMask.active = isShow;
    }

    setMaxCardsTip(maxCardsInfo:Texas.IMaxCardInfo){
        if (maxCardsInfo == undefined) {
            return;
        }
        let node = this.tabViewComp.maxCardsDes;
        let pattern = this.tabViewComp.patternCard;
        let atlasComp = node.getComponent(AtlasHandleComp);
        let cardsArray = [];
        let patternComp = pattern.getComponent(AtlasHandleComp);
        for (let c of maxCardsInfo.maxCards) {
            let card = Card.codeToIndex(c)
            cardsArray.push('pubilc_' + card);
        }
        atlasComp.fillSprites(cardsArray);
        patternComp.fillSprites([Define.PokerDes[maxCardsInfo.maxCardsType]])
    }

    //我方弃牌,执黑
    maskMyCards(){
        for (let hand of this.tabViewComp.meHands) {
            hand.blackPoker();
        }
    }

    //手牌是否全部值黑
    isHandsBlack(isBlack:boolean){
        for (let hand of this.tabViewComp.meHands) {
            hand.showBlack(isBlack)
        }
    }

    isHideMyCards(ishide:boolean){
        for (let hand of this.tabViewComp.meHands) {
            if (ishide) {
                hand.hide();
            }else{
                hand.show();
            }
        }
    }

    showMaxCards(isVisible:boolean){
        this.tabViewComp.maxCardsDes.active = isVisible;
    }

    //更新边池,展示
    updateSidePot(data:Texas.ISidePot[]){
        this.sidePool.updateSidePot(data);
    }

    showTwoHands(cards:number[]){
        let sp:PokerComponent[] = this.tabViewComp.meHands;
        sp[0].code = cards[0];
        sp[1].code = cards[1];
        sp[0].showPoker();
        sp[1].showPoker();
    }

    isShowSeekPlayer(isShow:boolean){
       
    }

    showShowPokerOnly(){
        let sp:PokerComponent[] = this.tabViewComp.meHands;
        sp[0].showCardOnly();
        sp[1].showCardOnly();
    }

    showCardsType(typeID:number){
        let node = this.tabViewComp.myTypeNode
        let atlas = node.getComponent(AtlasHandleComp);
        atlas.fillSprites([Define.PokerDes[typeID]]);
        // let strNode = this.tabViewComp.cardPattern
        // TableHelp.setNodeString(strNode,LanguageManager.t(Define.LocalPattern[typeID]));
        this.myTypeNode.active = true;
    }

   
    //定时调用
    updateBetAnim(isplay:boolean){
        if (isplay) {
            this.playAnim();
        }else{
            this.stopAnim();
        }
    }

    playanim:boolean = true;
    isPlayAnim:boolean = true;//是否载播放动画
    private playAnim(){
        if (this.isPlayAnim) {
            return;
        }
        this.isPlayAnim = true;
        this.playanim = true;
        this.addAnim.playAnim(0);
        this.tabViewComp.heguan.stopAllActions();
        TableHelp.schedule(this.tabViewComp.heguan,()=>{
            this.playanim = !this.playanim;
            if (this.playanim) {
                this.addAnim.playAnim(0)
            }else{
                this.addAnim.stopAnim(0);
            }
        },5)
    }

    private stopAnim(){
        if (!this.isPlayAnim) {
            return;
        }
        this.tabViewComp.heguan.stopAllActions();
        this.addAnim.stopAnim(0);
        this.isPlayAnim = false;
    }

    updateCountDwon(numb:number){
        let countNode = this.tabViewComp.countDownNode.getChildByName('numb');
        let des = LanguageManager.t(Define.OpTips[6]).format(numb);
        TableHelp.setNodeString(countNode,des);
    }

    setPotNumb(numb:number){
        numb = TableHelp.getRightMount(numb);
        this.showPot(numb > 0);
        if (numb > 0) {
            let lab = this.mainNode.getChildByName('numb');
            let bet = TableHelp.addThousands(numb);
            let des = LanguageManager.t(Define.OpTips[4]) + ':' + bet;
            TableHelp.setNodeString(lab,des);
        }
    }

    showPot(isShow:boolean){
        this.mainNode.active = isShow;
    }

    setHandState(isShow:boolean){
        this.tabViewComp.mhandNode.active = isShow;
        if (!isShow) {//弃牌使用
            this.myTypeNode.active = false;
        }
    }

    //添加座椅
    addSeat(index:number):cc.Node{
        let target = this.tabViewComp.seatState[index];
        let seatNode:cc.Node = null;
        if (target) {
            seatNode = TableHelp.AddChild(this.seatPrefab,target.node)
            seatNode.name = index.toString();
        }
        return seatNode;
    }

    isShowCountDown(isShow:boolean){
        this.tabViewComp.countDownNode.active = isShow
    }

    private pokerspos:cc.Vec2[] = [];
    onInit(){
        for (let idx = 0; idx < this.twoHands.length; idx++) {
            let hand = this.twoHands[idx];
            this.pokerspos.push(hand.node.position);
        }
        this.reset();
        this.isShowSeekPlayer(true);//默认显示
        this.stopAnim();
    };

    reset(){
        if (this.twoHands) {
            this.twoHands.forEach((e:PokerComponent)=>{
                e.reset();
                e.stopPokerAction();
            })
        }
        if (this.sidePool) {
            this.sidePool.reset();
        }
        if (this.tableRoot) {
            this.tableRoot.stopAllActions();
        }
        if (this.mainNode) {
            this.mainNode.active = false;
        }

        if (this.myTypeNode) {
            this.myTypeNode.active = false;
        }
        this.commonPokers.recycleAll();
        if (this.tabViewComp.countDownNode) {
            this.tabViewComp.countDownNode.active = false
        }
        this.showMaxCards(false);
        this.setHandState(false);
        this.setPatternMask(false);
        this.isShowSeekPlayer(false);
        this.resetMyPoker();
    }

    //重置我方手牌
    resetMyPoker(){
        for (let idx = 0; idx < this.twoHands.length; idx++) {
            this.resetOnePokerPos(idx)
        }
    }

    private resetOnePokerPos(idx:number){
        let hand = this.twoHands[idx];
        let pos = this.pokerspos[idx]
        if (hand && pos) {
            hand.node.position =pos;
            hand.node.scale = 1;
        }
    }

    //手牌移动
    pokersMove(idx:number,toNode:cc.Node,comp?:Function){
        let hand = this.twoHands[idx];

        this.resetOnePokerPos(idx);

        if (!hand) {
            return;
        }


        let handNode = hand.node;
        let worldPos = toNode.parent.convertToWorldSpaceAR(toNode.position);
        let localPos = handNode.parent.convertToNodeSpaceAR(worldPos);

        let time = 0.1//Define.handsMoveTime;
        let moveTo = cc.moveTo(time,localPos);
        let scalTo = cc.scaleTo(time,0.9);
        let func = cc.callFunc(()=>{
            if (comp) {
                comp();
            }
            hand.hide();
        })
        handNode.stopAllActions()
        let spawn = cc.spawn(moveTo,scalTo);
        handNode.runAction(cc.sequence(spawn,func));
    }

    //恢复手牌默认位置
    resumeHands(){
        for (let hand of this.twoHands) {
            hand.node.stopAllActions();
            hand.showPoker()
        }
        for (let cf of this.twoCardsEffect) {
            cf.resumeHands();
        }
    }

    beginDealCards(){
        for (let cf of this.twoCardsEffect) {
           cf.reset();
        }
        this.setHandState(true);
    }

    //我方发牌,加翻牌动画
    dealCardsMySelf(index:number,cards:number[]){
        let hand = this.twoHands[index];
        hand.code = cards[index];
        hand.showBack();
        hand.show();
        this.twoCardsEffect[index].dealMyCardsAction(this.dealerNode,()=>{

        });
    }

    //发牌结束
    dealOverCards(overfunc?:Function){
        let sound = true;
        for (let i = 0; i < 2; i++) {
            // TableHelp.rotateAction(this.twoHands[i].node,0.45,()=>{
            //     this.twoHands[i].showPoker();
            // },null);
            TableHelp.rotateActionScaltoEx(this.twoHands[i].node,0.1,0.2,()=>{
                this.twoHands[i].showPoker();
                if (sound) {
                    TexasSound.playRotatePoker();
                    if (overfunc) {
                        overfunc();
                    }
                    sound = false;
                }
            },null);
        }
    }


    throwCardsAction(){
        for (let tf of this.twoCardsEffect) {
            tf.throwMySelfCardsAction(this.dealerNode)
        }
        this.myTypeNode.active = false;
    }

    clear(){
        this.sidePool.clear();
        this.commonPokers.clear();
    }
}
